import { getTemplateNavHeaderStyles } from '@/components/webcomponents/NavHeader/NavHeaderContextual/NavHeaderContextual.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="contextual-fluid">
  <slot name="sectionTitle"></slot>
  <div class="right-group">
    <div class="contextual-links">
      <slot name="contextualMenu"></slot>
    </div>
    <div class="contextual-label">
      <slot name="label-btn"></slot>
    </div>
  </div>

</div>
`

class NavHeaderContextual extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderContextual connectedCallback', this)
  }
}

if (!customElements.get('ts-navheader-contextual')) {
  customElements.define('ts-navheader-contextual', NavHeaderContextual)
}
export { NavHeaderContextual }
